import React from 'react';
import Spinner from './components/Spinner';

export default function RampButton(props) {
	const { loading } = props;
	//console.log("Loading:", loading)
	return (
		<React.Fragment>
			<button type="button" {...props}>
				{loading ? <Spinner /> : <span>{props.children}</span>}
			</button>
		</React.Fragment>
	);
}

